'use client';

import { FC } from 'react';
import styles from './StickyNav.module.scss';
export interface StickyNavTab {
  id: string;
  label: string;
}
export interface StickyNavProps {
  tabs: StickyNavTab[];
  activeTab: string;
  onTabClick: (id: string) => void;
}
const StickyNav: FC<StickyNavProps> = ({
  tabs,
  activeTab,
  onTabClick
}) => {
  return <nav className={styles.nav} role="tablist" aria-label="Page sections" data-sentry-component="StickyNav" data-sentry-source-file="StickyNav.tsx">
            <div className={styles.inner}>
                {tabs.map(tab => <button key={tab.id} type="button" role="tab" aria-selected={activeTab === tab.id} className={`${styles.tab} ${activeTab === tab.id ? styles.active : ''}`} onClick={() => onTabClick(tab.id)}>
                        {tab.label}
                    </button>)}
            </div>
        </nav>;
};
export default StickyNav;